import React, { useState, useEffect } from 'react';
import {
    Text, SearchBox, Label, Stack, ChoiceGroup, IStackStyles, Image, ImageFit,
    IconButton, Dropdown, PrimaryButton, Spinner, MessageBar, MessageBarType
} from '@fluentui/react';
import setup from "../../Containers/setup";
import { useDispatch, useSelector } from 'react-redux';
import Type from "../../Redux/Type";
import { getListHuyen, getListXa, getSearchList, getSearchListEnter } from '../../Containers/Search'
import { onOpenRightPanel } from "../../Containers/RightPanelAction";
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { convertLatLonToXY } from '../../Containers/Converter';
import { onMoveToMap } from '../../Containers/MapView';
import { onLoadXa } from '../../Containers/ViTriHanhChinh';
import CardDownApp from '../Menu/CardDownApp';



const Search = () => {
    const dispatch = useDispatch();
    const {
        searchText,
        modeSearch,
        listDistrict,
        wardSelected,
        markerPosition,
        loadingSearch,
        loadingLoginEnter,

        districtSelectedSearch,
        wardSelectedSearch
    } = useSelector(state => state.searchState);
    const userInfo = useSelector(state => state.userInfo);
    const [isDidMount, setDidMount] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showTroGiup, setShowTroGiup] = useState(false);
    const [warningMessage, setWarningMessage] = useState('');
    const [optionModeSearch] = useState([
        // { key: 'byName', text: 'Theo tên chủ sử dụng', disabled: !userInfo },
        { key: 'byPosition', text: 'Theo tọa độ' },
        { key: 'byToThua', text: 'Theo số tờ thửa' }
    ])
    const { menuDiaGioi, huyenselect } = useSelector(state => state.diaGioi);

    const [huyenChosen, setHuyenChosen] = useState({ key: menuDiaGioi[1].key, text: menuDiaGioi[1].text });
    const [arrHuyen, setArrHuyen] = useState(menuDiaGioi.filter(e => e.MaHuyen !== 0))


    useEffect(() => {
        // console.log('isDidMount '+ isDidMount)
        // if (!isDidMount)
        // {
        // console.log('isDidMountSEt '+ isDidMount)

        setDidMount(true);
        if (markerPosition) {
            dispatch({ type: Type.SET_SEARCH, route: 'searchText', value: `${markerPosition['lat']}, ${markerPosition['lng']}` })
        }
        dispatch({ type: Type.SET_SEARCH, route: 'wardSelected', value: null });
        if (!userInfo)
            dispatch({ type: Type.SET_SEARCH, route: 'modeSearch', value: 'byToThua' });
        // }
    }, [isDidMount, dispatch, listDistrict.length, userInfo]);

    const onCallAPISearch = (route, payload) => {

        setErrorMessage('');
        dispatch({ type: Type.SET_SEARCH, route: 'loadingSearch', value: true });
        dispatch({ type: Type.SET_SEARCH, route: 'listResult', value: [] });
        let onSuccess = (statusCode, response) => {
            dispatch({ type: Type.SET_SEARCH, route: 'loadingSearch', value: false });
            if (statusCode === 200) {
                if (response.length) {
                    dispatch({ type: Type.SET_STATE_RIGHT_PANEL, route: 'isMinimized', value: false });
                    dispatch({ type: Type.SET_SEARCH, route: 'listResult', value: response });

                    // Tắt form tìm kiếm 
                    dispatch({ type: Type.SET_STATE_POPUP_PANEL, route: 'isShowForPopup', value: false });
                    dispatch({ type: Type.SET_STATE_POPUP_PANEL, route: 'routeContent', value: null });

                    onOpenRightPanel('result')
                }
                else
                    setWarningMessage('Không tìm thấy kết quả nào')
            } else {
                setErrorMessage(response)
            }
        };
        getSearchList(route, payload, onSuccess);
        //getSearchListEnter(route, payload, onSuccess)
    };

    const onClearSearchText = () => {
        dispatch({ type: Type.SET_SEARCH, route: 'searchText', value: '' });
        dispatch({ type: Type.SET_SEARCH, route: 'listResult', value: [] });
        dispatch({ type: Type.SET_SEARCH, route: 'markerPosition', value: null });
        dispatch({ type: Type.SET_SEARCH, route: 'pickMapOn', value: false });

        dispatch({ type: Type.SET_STATE_HIEN_TRANG, route: 'makerPosition', value: {} });
        dispatch({ type: Type.SET_STATE_HIEN_TRANG, route: 'pickedPolygon', value: [] });
        dispatch({
            type: Type.SET_STATE_HIEN_TRANG,
            route: 'dataTrichDoPicked',
            value: null
        });


    }
    const onChangeSearchText = (_, value) => dispatch({ type: Type.SET_SEARCH, route: 'searchText', value });

    const onChangeModeSearch = (_, optionChoose) => {

        dispatch({ type: Type.SET_SEARCH, route: 'modeSearch', value: optionChoose.key })
        onClearSearchText()
        dispatch({ type: Type.SET_STATE_RIGHT_PANEL, route: 'isShow', value: false });
        dispatch({ type: Type.SET_STATE_RIGHT_PANEL, route: 'routeContent', value: null });
    };



    const onChangeHuyen = (_, option) => {
        let huyen = { key: option.key, text: option.text }
        // let center = {
        //     lat: parseFloat(option.latitude),
        //     lng: parseFloat(option.longitude)
        // };

        // onMoveToMap(center)
        dispatch({ type: Type.SET_SEARCH, route: 'wardSelectedSearch', value: null });
        dispatch({ type: Type.SET_SEARCH, route: 'districtSelectedSearch', value: huyen });
        setHuyenChosen(huyen)
        // onLoadXa(huyen)
    }

    const onWardChange = (_, wardSelected) => {
        // let center = {
        //     lat: parseFloat(wardSelected.latitude),
        //     lng: parseFloat(wardSelected.longitude)
        // };
        // onMoveToMap(center)
        dispatch({ type: Type.SET_SEARCH, route: 'wardSelectedSearch', value: wardSelected })
    };

    const onSearchPress = () => {

        setWarningMessage('');

        dispatch({ type: Type.SET_STATE_HIEN_TRANG, route: 'makerPosition', value: {} });
        dispatch({ type: Type.SET_STATE_HIEN_TRANG, route: 'pickedPolygon', value: [] });
        dispatch({
            type: Type.SET_STATE_HIEN_TRANG,
            route: 'dataTrichDoPicked',
            value: null
        });

        // if (!userInfo) {
        //     return alert('Vui lòng đăng nhập để tìm kiếm ')
        // }
        if (!searchText.trim())
            setErrorMessage('Vui lòng nhập từ khóa cần tìm')
        if (modeSearch === 'byToThua') {
            let arraySearchText = searchText.split('/');
            if (arraySearchText.length !== 2) {
                setErrorMessage('Vui lòng nhập đúng cú pháp tìm kiếm số tờ/số thửa. Ví dụ để tìm thửa 123 thuộc tờ 10, bạn hãy nhập 10/123');
            }
            else {
                //if (wardSelectedSearch) {
                    setErrorMessage('');
                    let SOTO = arraySearchText[0].trim(),
                        SOTHUA = arraySearchText[1].trim(),
                        MADVHC = wardSelectedSearch ? wardSelectedSearch.MaDVHC : huyenChosen.key,
                        //MADVHC = wardSelected ? wardSelected.id_dvhc : huyenChosen.key,

                        payload = {
                            MaDvhc: MADVHC,
                            SoTo: SOTO,
                            SoThua: SOTHUA,
                            TenChu: '',
                            Point: ''
                        };
                    onCallAPISearch(modeSearch, payload);
                // } else {
                //     setErrorMessage('Vui lòng chọn Phường/Xã/Thị Trấn cần tìm');
                // }
            }
        }
        else if (modeSearch === 'byPosition') {
            let arraySearchText = searchText.split(',');
            if (arraySearchText.length !== 2) {
                setErrorMessage('Vui lòng nhập đúng cú pháp tìm kiếm tọa độ (lat, long) . Ví dụ: 11.318257, 106.099454 ');
            }
            else {
                let lat = parseFloat(arraySearchText[0].trim())
                let lng = parseFloat(arraySearchText[1].trim())
                dispatch({ type: Type.SET_SEARCH, route: 'markerPosition', value: { lat: lat, lng: lng } })
                onMoveToMap({ lat: lat, lng: lng })
                let resultconvert = convertLatLonToXY({ latitude: lat, longitude: lng })
                let payload = {
                    MaDvhc: 0,//wardSelected.searchID,
                    SoTo: '',
                    SoThua: '',
                    TenChu: '',
                    Position: { Longitude: lng, Latitude: lat },
                    Point: `POINT (${resultconvert.y} ${resultconvert.x})`
                };
                onCallAPISearch(modeSearch, payload);

            }

        }
        else {
            let payload = {
                TenChu: searchText,
                MaDvhc: wardSelectedSearch ? wardSelectedSearch.MaDVHC : huyenChosen.key,
                SoTo: '',
                SoThua: ''
            };

            onCallAPISearch(modeSearch, payload);
        }
    };
    const onShowTroGiup = () => {
        setShowTroGiup(!showTroGiup)
    }
    const onSetPicker = () => {
        // if(refMapView){
        //     // refMapView.props.options = {...refMapView.props.options, draggableCursor: `url(${process.env.PUBLIC_URL}/images/icons/pin.png) 10 10 , crosshair `}
        // }
        dispatch({ type: Type.SET_SEARCH, route: 'pickMapOn', value: true })
        dispatch({ type: Type.SET_STATE_POPUP_PANEL, route: 'isShowForPopup', value: false });
    }
    const emojiIcon: IIconProps = { iconName: 'MapPin' }
    const noteIcon: IIconProps = { iconName: 'Info' }
    const stackStyles: IStackStyles = {
        root: {
            width: `100%`,
        },
    };

    return (
        <div className='modal-content-container'>
            <div className='animated-panel'>
                <Text variant='xLarge' className='title'>Tìm kiếm</Text>

                <Stack horizontal tokens={{ childrenGap: 10 }} styles={stackStyles}>
                    <SearchBox
                        placeholder={modeSearch === 'byName' ? 'Nhập tên chủ sử dụng' : modeSearch === 'byToThua' ? 'Nhập số tờ/số thửa (VD: 10/123)' : 'Nhập tọa độ điểm lat,lng (VD: 11.318257, 106.099454) '}
                        onChange={onChangeSearchText}
                        className="searchBoxCustom"
                        value={searchText}
                        onClear={onClearSearchText}
                        onSearch={onSearchPress}
                        disabled={loadingSearch || loadingLoginEnter}
                    />
                    {
                        modeSearch === "byPosition" ?
                            <Stack horizontal >
                                <div>
                                    <TooltipHost
                                        content="Trợ giúp"
                                        // id={'tooltipId'}
                                        // calloutProps={calloutProps}
                                        // styles={hostStyles}
                                        setAriaDescribedBy={false}
                                    >
                                        <IconButton id={'btn-help'} iconProps={noteIcon} aria-label="Trợ giúp" onClick={onShowTroGiup} />
                                    </TooltipHost>
                                    {
                                        showTroGiup &&
                                        <div className='Tooltip-picker-search' id="Search-Google-Picker">
                                            <div style={styles.textTooltip}>
                                                <strong style={{ fontWeight: 'bold' }}> Cách lấy tọa độ trên Google </strong>
                                                <p style={{ fontSize: 12 }} >Chọn điểm trên google map, copy tọa độ vào ô tìm kiếm </p>
                                            </div>
                                            <div style={styles.tooltipImg}>
                                                <img style={styles.helpimg1} src={process.env.PUBLIC_URL + 'images/huongdan/getPositionGG.png'} />
                                            </div>
                                            <div style={styles.textTooltip}>
                                                <strong style={{ fontWeight: 'bold' }}> Chọn trên trang </strong>
                                                <p style={{ fontSize: 12 }} >Tắt lớp quy hoạch nếu không thể chọn được tọa độ</p>
                                            </div>
                                            <div style={styles.tooltipImg}>
                                                <img style={styles.helpimg1} src={process.env.PUBLIC_URL + 'images/huongdan/getPosition.png'} />
                                            </div>
                                        </div >
                                    }
                                </div>
                                <TooltipHost
                                    content="Chọn trên bản đồ"
                                    // id={'tooltipId'}
                                    // calloutProps={calloutProps}
                                    // styles={hostStyles}
                                    setAriaDescribedBy={false}
                                >
                                    <IconButton iconProps={emojiIcon} aria-label="Chọn trên bản đồ" onClick={onSetPicker} />
                                </TooltipHost>
                            </Stack> : null
                    }
                </Stack>
                {warningMessage ?
                    <div style={{ marginTop: 5, marginBottom: 5 }}>
                        <MessageBar
                            messageBarType={MessageBarType.warning}
                            isMultiline={true}
                        >
                            {warningMessage}
                        </MessageBar>
                    </div>
                    : null
                }
                <div>
                    <div style={styles.subTitleRow}>
                        <Label required={true} styles={styles.labelTitle}>Tìm theo</Label>
                    </div>
                    <ChoiceGroup
                        styles={styles.chosenGroup}
                        selectedKey={modeSearch}
                        options={optionModeSearch}
                        onChange={onChangeModeSearch}
                        disabled={loadingSearch || loadingLoginEnter}
                    />
                </div>
                <div style={styles.subTitleRow}>
                    <Label required={true} styles={styles.labelTitle}>Khu vực tìm kiếm</Label>
                </div>
                <Dropdown
                    placeholder="Huyện/Thị xã/Thành phố"
                    options={arrHuyen}
                    styles={styles.dropdownMenu}
                    //selectedKey={huyenChosen.key}
                    selectedKey={districtSelectedSearch.key}
                    onChange={onChangeHuyen}
                    disabled={modeSearch === 'byPosition' || loadingSearch || loadingLoginEnter}
                />
                <Dropdown
                    placeholder="Xã/Phường/Thị trấn"
                    options={arrHuyen.filter(e => e.key === huyenChosen.key)[0]['arrXa']}
                    selectedKey={wardSelectedSearch && wardSelectedSearch.key}
                    onChange={onWardChange}
                    styles={styles.dropdownMenu}
                    disabled={modeSearch === 'byPosition' || loadingSearch || loadingLoginEnter}
                />

                {errorMessage ?
                    <div style={{ marginTop: 5, marginBottom: 5 }}>
                        <MessageBar
                            messageBarType={MessageBarType.severeWarning}
                            isMultiline={true}
                        >
                            {(errorMessage && (errorMessage + '').trim()) ? errorMessage : 'Đã có lỗi xảy ra vui lòng thử lại sau'}
                        </MessageBar>
                    </div>
                    : null
                }

                <PrimaryButton
                    styles={{ root: { marginTop: 20 } }}
                    onClick={onSearchPress}
                    disabled={loadingSearch || loadingLoginEnter}
                    text='Tìm'
                />
                <br />

                <Spinner
                    label="Vui lòng đợi trong giây lát..."
                    labelPosition="right"
                    hidden={!loadingLoginEnter && !loadingSearch}
                />

                <CardDownApp />
            </div>
        </div>
    )
}

export default Search


const styles = {
    subTitleRow: {
        height: 30,
        marginTop: 2,
        display: 'flex',
        alignItems: 'flex-end'
    },
    labelTitle: {
        root: {
            textAlign: 'left'
        }
    },
    chosenGroup: {
        label: {
            textAlign: 'left',

        },
        root: {
            marginBottom: -5,
        },
    },
    searchRoot: {
        root: {
            width: '100%'
        }
    },
    dropdownMenu: {
        root: {
            marginTop: 7,
        },
        title: {
            textAlign: 'left'
        },
        errorMessage: {
            textAlign: 'left'
        }
    },
    helpimg1: {
        width: '100%',
        objectFit: 'cover',
        height: 200,
    },
    textTooltip: {
        fontSize: 16, textAlign: 'center'
    },
    tooltipImg: { textAlign: 'center', marginTop: 10 }

};

